import { lineRhythm } from './strategyRhythm';
import type { AdvancedRotationRules } from '../types';

export const emptyAdvancedRules = (): AdvancedRotationRules => ({ lines: {}, quarterBreakResets: false });
const record = (value: unknown): value is Record<string, unknown> => Boolean(value) && typeof value === 'object' && !Array.isArray(value);

export const isAdvancedRotationRules = (value: unknown): value is AdvancedRotationRules => {
  if (!record(value) || typeof value.quarterBreakResets !== 'boolean' || !record(value.lines)) return false;
  return Object.values(value.lines).every(line => record(line) && ['maxConsecutiveBlocks', 'minRestBlocks', 'maxSubstitutionsPerMoment'].every(key =>
    line[key] == null || (typeof line[key] === 'number' && Number.isInteger(line[key]) && line[key] >= 1 && line[key] <= (key === 'maxSubstitutionsPerMoment' ? 16 : 25))));
};

export const rotationBlockTime = (blocks: number, rhythm: string, quarterMinutes?: number): string | null => {
  const moments = Number(rhythm);
  if (!quarterMinutes || quarterMinutes <= 0 || !rhythm.trim() || !Number.isInteger(moments) || moments < 0) return null;
  const seconds = Math.round(quarterMinutes * 60 * blocks / (moments + 1));
  return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
};

/** Shared event times; each line has its own evenly spaced quarter blocks. */
export function advancedRotationStarts(lines: { key: string; positions: string[] }[], strategy: { rhythm: string; rhythms: Record<string, string> }, duration: number): number[] {
  const starts = [...new Set(lines.flatMap(line => {
    const count = Number(lineRhythm(line, strategy.rhythms, strategy.rhythm));
    return Array.from({ length: count + 1 }, (_, index) => Math.round(index * duration / (count + 1)));
  }))].sort((a, b) => a - b);
  return starts;
}
